:host {
    display: contents;
}
